export default __webpack_public_path__ + "static/media/laptop.a8cfafa3.png";